module.exports = __webpack_public_path__ + "img/hot.9b412843.png";